import { nextTick } from 'vue'
import CUSTOM_FIELD_TYPES from '@/constants/customFieldTypes'

export default function(inputCustomFields: Inputs, customFieldConfigItems?: CustomFieldConfig[]) {
  /**
   * サーバから受け取った custom field の内容を input の型に assign
   */
  const initInputCustomFields = (): void => {
    customFieldConfigItems?.forEach(v => {
      // 複数選択系のものは配列
      // 単一チェックボックスは「0 = 未チェック」（サーバ側は 1 / 0 の値が来ることを期待している）
      // それ以外はテキスト入力フィールド
      Object.assign(inputCustomFields, {
        [v.id]: {
          name: `${v.name}[value]`,
          value: v.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX_MULTI || v.fieldType === CUSTOM_FIELD_TYPES.SELECT_MULTI
            ? []
            : v.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX
              ? 0
              : '',
          validationScheme: v.validationScheme,
        }
      })
    })
  }

  /**
   * DOM 生成後初期処理
   */
  nextTick(() => {
    initInputCustomFields()
  })

  /**
   * ブラウザの「戻る」・「進む」が押下された際にカスタムフィールドのデータを初期化する
   * @description 基本、「戻る」・「進む」であっても、JS オブジェクト自体は揮発するが、
   *              テキストフィールド系以外のフォーム系 HTML 要素（select や checkbox 等）は、見た目上選択されているかのような表示になってしまうため、
   *              結果、JS オブジェクトである state の内容は揮発しているが、HTML 要素側の「見た目上」は、さも選択されているかのように振る舞われており、state との乖離が発生する。
   *              よって、ブラウザのイベントが発火する際にカスタムフィールドの初期化を行うことで、明示的にコンポーネントの watcher を動かし、初期化データでバインドしてからブラウザ遷移させる
   */
  window.addEventListener('pagehide', () => {
    initInputCustomFields()
  })

  return {
    // method
    initInputCustomFields,
  }
}
